
import { useEffect, type Dispatch, type SetStateAction } from 'react'
import { useQueryClient } from 'react-query'

import { type Column, Table } from '../../../../../../components/Table'
import { fetchAdmins, useAdminsQuery } from '../../../../../../services/hooks/admins/queries/useAdminsQuery'
import { type FiltersDomain } from '../../../../../../types/domain/filters-domain'

type Props = {
  filters: FiltersDomain
  columns: Column[]
  setFilters: Dispatch<SetStateAction<FiltersDomain>>
}

export const TableWithManuallyPagination = ({
  filters,
  columns,
  setFilters,
}: Props) => {
  const queryClient = useQueryClient()
  const { data, refetch } = useAdminsQuery(filters)

  const handlePageChange = (pageNumber: number) =>
    setFilters((prevState) => ({
      ...prevState,
      page: pageNumber,
    }))

  const handleChangingRegistersPerPage = (registersPerPage: number) => {
    setFilters((prevState) => ({
      ...prevState,
      page: 1,
      take: registersPerPage,
    }))
  }

  useEffect(() => {
    if (data?.meta?.hasNextPage) {
      queryClient.prefetchQuery(['admins', filters], () => {
        return fetchAdmins(filters)
      })
    }
  }, [data, filters, queryClient])

  useEffect(() => {
    refetch()
  }, [])

  return (
    <Table
      columns={columns}
      rows={data?.data || []}
      currentPage={filters.page}
      registersPerPage={filters.take}
      totalCountOfRegisters={data?.meta?.itemCount}
      onPageChange={handlePageChange}
      noContentMessage="Sem registro de admin(s)"
      onChangingRegistersPerPage={handleChangingRegistersPerPage}
    />
  )
}
